import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Paper } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import {
  deleteStatisticsEncouragementMessage,
  getStatisticsEncouragementMessages,
} from '../../../store/statisticsEncouragementMessage/action';
import {
  STATISTICS_ENCOURAGEMENT_MESSAGE_ADD,
  STATISTICS_ENCOURAGEMENT_MESSAGE_EDIT,
} from '../../../constants/routes';
import ValidationDialog from '../../../components/ValidationDialog/ValidationDialog';
import PageCircularProgress from '../../../components/PageCircularProgress/PageCircularProgress';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { useUserAuth } from '../../../contexts/UserAuthContext.js';

export default function StatisticsEncouragementMessagesPage() {
  const {
    pending,
    content,
    error,
    sending,
  } = useSelector((state) => state.statisticsEncouragementMessage);
  const dispatch = useDispatch();
  const { token } = useUserAuth();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [encouragementToDelete, setEncouragementToDelete] = useState(null);

  if (!content && !pending && !error && token !== null) {
    dispatch(getStatisticsEncouragementMessages(token));
  }

  const handleAdd = () => {
    navigate(STATISTICS_ENCOURAGEMENT_MESSAGE_ADD);
  };

  const handleEdit = (statisticsEncouragementMessage) => {
    navigate(
      STATISTICS_ENCOURAGEMENT_MESSAGE_EDIT
        .replace(':encouragementId', statisticsEncouragementMessage.id),
    );
  };

  const handleToggleDialog = (encouragement) => {
    setEncouragementToDelete(encouragement);
    setOpenDialog(!openDialog);
  };

  const handleDelete = (encouragement) => {
    dispatch(deleteStatisticsEncouragementMessage(token, encouragement))
      .then(handleToggleDialog);
  };

  return (
    <Container maxWidth={false}>
      <ValidationDialog
        handleClose={handleToggleDialog}
        openDialog={openDialog}
        handleAction={() => handleDelete(encouragementToDelete)}
        title="Êtes-vous sûr de vouloir supprimer cet encouragement ?"
        text="Vous êtes sur le point de supprimer un encouragement. Attention, cette action est irréversible."
        sending={sending}
      />
      <PageTitle
        title="Encouragements de suivi"
        onClick={handleAdd}
        actionTitle="Ajouter un encouragement"
      />
      {(
        pending || content === null
      ) && <PageCircularProgress />}
      {content !== null
        && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Titre</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Limite minimum</TableCell>
                  <TableCell>Limite maximum</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {content.map((encouragement) => (
                  <TableRow key={encouragement.id}>
                    <TableCell>
                      {encouragement.title}
                    </TableCell>
                    <TableCell>
                      {encouragement.message}
                    </TableCell>
                    <TableCell>
                      {encouragement.min_limit}
                    </TableCell>
                    <TableCell>
                      {encouragement.max_limit}
                    </TableCell>
                    <TableCell
                      align="right"
                    >
                      <IconButton
                        id="edit"
                        aria-label="update"
                        onClick={() => handleEdit(encouragement)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        id="delete"
                        aria-label="update"
                        onClick={() => handleToggleDialog(encouragement)}
                        color="primary"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
    </Container>
  );
}
